// component
import { MdCategory, MdDashboard, MdGames, MdGroups, MdPostAdd } from 'react-icons/md';
import { MdShoppingCart } from 'react-icons/md';
import { IoListCircle } from 'react-icons/io5';
import { FaTrophy } from 'react-icons/fa';
import { BiTransfer, BiCommentDetail } from 'react-icons/bi';
import { CgDisplaySpacing } from 'react-icons/cg';
import { AiOutlineTeam } from 'react-icons/ai';
import { GiTabletopPlayers } from 'react-icons/gi';
import { MdPhotoLibrary } from 'react-icons/md';
import { TbReceipt } from 'react-icons/tb';
import { RiSmartphoneLine, RiGlobalLine } from 'react-icons/ri';
import { MdForum } from 'react-icons/md';

import Page from '../../../data/Page'

const role = localStorage.getItem("role");
const isAdmin = role === "admin" || role === "superadmin";
const isOrganizer = role === "organization";
console.log({ role, isAdmin, isOrganizer })

const imageLibraryTab = {
  title: 'Image Library',
  path: `${Page.IMAGE_LIBRARY}`,
  icon: <MdPhotoLibrary size={20} />,
};

let adminTabs = [{
  title: 'Dashboard',
  path: Page.DASHBOARD,
  icon: <MdDashboard size={20} />,
},
{
  title: 'Products',
  path: '/products',
  end: true,
  icon: <MdShoppingCart size={20} />,
},
{
  title: 'Product Categories',
  path: '/products/categories',
  icon: <IoListCircle size={20} />,
},
{
  title: 'Quizzes',
  path: '/quiz',
  icon: <MdPostAdd size={20} />,
},
{
  title: 'Users',
  path: `${Page.USER}`,
  icon: <MdGroups size={20} />,
},
{
  title: 'Category',
  path: Page.CATEGORY,
  icon: <MdCategory size={20} />,
},
{
  title: 'Games',
  path: `${Page.GAME}`,
  icon: <MdGames size={20} />,

},
{
  title: 'Teams',
  path: `${Page.TEAM}`,
  icon: <AiOutlineTeam size={20} />,

},
{
  title: 'Players',
  path: `${Page.PLAYER}`,
  icon: <GiTabletopPlayers size={20} />,

},
{
  title: 'Post',
  path: `${Page.POST}`,
  icon: <MdPostAdd size={20} />,

},
{
  title: 'Banner',
  path: `${Page.BANNER}`,
  icon: <CgDisplaySpacing size={20} />,
},
{
  title: 'Live Feed',
  path: `${Page.FEED}`,
  icon: <CgDisplaySpacing size={20} />,
},
{
  title: 'Section',
  path: `${Page.SECTION}`,
  icon: <CgDisplaySpacing size={20} />,
}, {
  title: 'Withdrawal',
  path: `${Page.WITHDRAWAL}`,
  icon: <BiTransfer size={20} />,
},
{
  title: 'Offers',
  path: `${Page.OFFERS}`,
  icon: <BiTransfer size={20} />,
},
{
  title: 'Notification',
  path: `${Page.NOTIFICATION}`,
  icon: <BiCommentDetail size={20} />,
},
{
  title: 'Lobby',
  path: '/lobby',
  icon: <MdForum size={20} />,
},
{
  title: 'Daily Rewards',
  path: '/rewards',
  icon: <MdGames size={20} />,
},
{
  title: 'Subscriptions',
  path: '/subscriptions',
  icon: <MdShoppingCart size={20} />,
},
{
  title: 'Reward Requests',
  path: '/reward-requests',
  icon: <MdForum size={20} />,
},
{
  title: 'Reward Postbacks',
  path: '/reward-postbacks',
  icon: <MdForum size={20} />,
},
imageLibraryTab,
{
  title: 'App Version',
  path: `${Page.VERSION}`,
  icon: <RiSmartphoneLine size={20} />,
},
{
  title: 'Countries',
  path: `${Page.COUNTRY}`,
  icon: <RiGlobalLine size={20} />,
}
]

let navConfig = [
  {
    title: 'Tournaments',
    path: `${Page.TOURNAMENT}`,
    icon: <FaTrophy size={20} />,
  },
  {
    title: 'Orders',
    path: '/orders',
    icon: <TbReceipt size={20} />,
  },
];

if (isAdmin) {
  navConfig = [...navConfig, ...adminTabs]
} else if (isOrganizer) {
  navConfig = [...navConfig, imageLibraryTab]
}

console.log(navConfig)

export default navConfig;
